
export default function criarAgendamentoPublicDTO({ DATA, IDHORARIO, IDCADASTRO, IDESPECIALIDADE }) {
  return {
    DATA,
    IDHORARIO,
    IDCADASTRO,
    IDESPECIALIDADE,

    // Campos internos  
    CANCELADA: false,
    REALIZADO: false,
    PAGO: false,
    TIPOAGENDAMENTO: "C"
  };
}